module.exports = __webpack_public_path__ + "static/media/loaderUpload3.6e845108.gif";